import React from "react";
import * as Styles from "./Style";
import * as Images from "../../images";
import { List, ListItem, ListItemText } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { selecteQuizTitle } from "../../store/courseTestSelector";
import { useSelector } from "react-redux";

const HeaderTest = () => {
  const quizTitle = useSelector(selecteQuizTitle);

  const STATIC = [
    "قم بإنجاز هذا الاختبار بعد مشاهدة الدرس كاملاً لتحقق أقصى استفادة ممكنة.  ",
    "يمكنك إعادة هذا الاختبار حسب الرغبة ولكن علامة الاختبار النهائية سوف تكون أعلى علامة تحققها في المحاولات الثلاثة الأولى فقط.  ",
    "عند تقديم الاختبار سوف نشير الى الأسئلة التي إجابتها صحيحة والأسئلة التي أجوبتها خاطئة، ولكن لن تظهر الإجابات الصحيحة للأسئلة  إلا بعد المحاولة الثالثة.",
  ];

  return (
    <Styles.HeaderComp>
      <Styles.LinkIcon to={-1}>
        <Styles.ImageArrow src={Images.Arrow} />
      </Styles.LinkIcon>
      <Styles.HeaderTextComp>
        <Styles.HeaderText variant="h3">اختبار {quizTitle}</Styles.HeaderText>
        <Styles.HeaderTextSecondary>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {STATIC.map((value) => (
              <ListItem sx={{ display: "flex", gap: "8px", py: "0px" }}>
                <FiberManualRecordIcon sx={{ fontSize: "12px" }} />
                <ListItemText primary={value} />
              </ListItem>
            ))}
          </List>
        </Styles.HeaderTextSecondary>
      </Styles.HeaderTextComp>
    </Styles.HeaderComp>
  );
};

export default HeaderTest;
